import { ISelectOption } from 'components/forms/Selects'
import { getNewCarrierStatus } from 'utils/carriers/getNewCarrierStatus'

export const getOptionsWithNewCarrierStateLabels = (
  options: ISelectOption<string>[],
  enabled: boolean
): ISelectOption<string>[] => {
  return options.map(option => ({
    ...option,
    label: getNewCarrierStatus(option.label, enabled),
  }))
}
